// extracted by mini-css-extract-plugin
module.exports =  {"adminJiraIssueForm":"n_sgh37V"};